import type { BlockDef } from '../../prop-types.ts'
import { EMPTY_TEXT } from '../../text.ts'

export const team: BlockDef = {
  type: 'team',
  v: 1,
  label: { en: 'Team', ar: 'الفريق' },
  scope: 'page',
  description: 'The people: a photograph, a name and a role for each.',
  whenToUse: 'An About page, a clinic, a law firm, a salon — anywhere the people are the reason somebody chooses the business.',
  whenNotToUse: 'For logos of clients or partners — those are a Gallery. For one founder’s story — that is Text beside an Image.',
  variants: [
    { value: 'grid', label: { en: 'Grid', ar: 'شبكة' } },
    { value: 'row', label: { en: 'One row', ar: 'صف واحد' } },
  ],
  fields: [
    { key: 'heading', label: { en: 'Heading', ar: 'العنوان' }, type: { kind: 'text' }, default: EMPTY_TEXT },
    {
      key: 'members',
      label: { en: 'People', ar: 'الأشخاص' },
      type: {
        kind: 'list',
        max: 24,
        item: [
          {
            key: 'photo',
            label: { en: 'Photo', ar: 'الصورة' },
            type: { kind: 'image' },
            default: { status: 'placeholder', description: EMPTY_TEXT, orientation: 'portrait' },
          },
          // ⚠️ A PERSON'S NAME IS STILL A `text` FIELD, not a `lit`. It is the one place where the
          // "same in both languages" shortcut is tempting and wrong: أحمد and Ahmed are the same
          // person and not the same string, and a site that shows Latin names to an Arabic visitor
          // is the exact failure the bilingual model exists to prevent.
          { key: 'name', label: { en: 'Name', ar: 'الاسم' }, type: { kind: 'text' }, default: EMPTY_TEXT },
          { key: 'role', label: { en: 'Role', ar: 'الدور' }, type: { kind: 'text' }, default: EMPTY_TEXT },
        ],
      },
      default: [],
      requiredForPublish: true,
    },
  ],
}
